// extracted by mini-css-extract-plugin
export default {"scottSecretSantaApp":"App_scottSecretSantaApp__7geGM"};